import { Grid,Stack } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from "date-fns/locale";
import { useCallback,useContext } from "react";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

export default function Hora({ subitem, itemId }: props) {
  const { setModelo } = useContext(NewFormContext);

  const handleValue = useCallback((newValue: Date | null) => {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((si) =>
              si.id === subitem.id
                ? {
                  ...si,
                  padrao: newValue ? newValue.getTime() : null
                }
                : si
            )
          }
          : item
      )
    }));
  }, [setModelo, itemId, subitem.id]);

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <TimePicker
              value={subitem.padrao ? new Date(subitem.padrao as number) : null}
              sx={{ width: '100%' }}
              slotProps={{
                actionBar: {
                  actions: ['clear', 'accept'],
                },
                field: {
                  readOnly: true,
                },
              }}
              localeText={{
                clearButtonLabel: 'Limpar',
              }}
              onChange={(newValue) => {
                handleValue(newValue);
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Stack >
  );
}
